// isFinite,
var isNil = function isNil(value) {
  /**
   * isNil(null) => true
   * isNil() => true
   */
  return value === null || value === undefined;
};

module.exports = isNil;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-nil.js
// module id = 5
// module chunks = 0